<template>
    <!--simply show my logo-->
    <img :style="style"
         alt="Sxtanna Logo"
         src="../assets/sxtanna.svg">
</template>

<script>
    export default {
        name: "Logo",
        props: {
            size: {
                type: Number,
                default: 250,
            }
        },
        computed: {
            style() {
                let ratio = 0.5;
                let small = this.$isMobile();

                return `
                width: ${small ? (this.size * ratio) : this.size}px;
                height: ${small ? this.size * ratio : this.size}px;`;
            }
        }
    }
</script>

<style scoped>
</style>